import Sortable from 'sortablejs';
export default class DnDSort {
    constructor(_element) {
        this._element = _element;
        this._updateOrder = (item, index) => {
            // update order
            const orderInput = item.querySelector("[data-order]");
            if (orderInput) {
                orderInput.value = index.toString();
            }
        };
        const sortable = new Sortable(this._element, {
            handle: '[data-handle]', draggable: "[data-draggable]",
            ghostClass: "dnd-sort-ghost",
            dragClass: "dnd-sort-drag",
            // Changed sorting within list
            onUpdate: (/**Event*/ evt) => {
                // update order
                [].slice.call(this._element.querySelectorAll("[data-draggable]")).forEach(this._updateOrder);
            },
        });
        console.log(sortable);
    }
}
[].slice.call(document.querySelectorAll("[data-dnd-sort]")).forEach(item => new DnDSort(item));
